export const ShareLinkModifiers = {
  CLIENT_EMAIL: "c",
  NO_TURN_OFF: "o",
  HIDE_TURN_OFF: "s",
  HIDE_BOTTOM_BAR: "b",
  HIDE_EXPORTS: "e",
}